import script from "./CvrUploadList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CvrUploadList.vue?vue&type=script&setup=true&lang=ts"

import "./CvrUploadList.vue?vue&type=style&index=0&id=6c12dd34&lang=css"
import "./CvrUploadList.vue?vue&type=style&index=1&id=6c12dd34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c12dd34"]])

export default __exports__